import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Container, Row, Col } from "reactstrap"
import History from "./History"
import StaffDecisions from "./StaffDecisions"
import Decisions from "../Decisions"
import DetailsPlasticBags from "../PlasticBags/DetailsPlasticBags"
import DisposalDetails from "../Disposal/DisposalDetails"

import DetailsRotterdam from "../ExportLicense/DetailsRotterdam"
import DetailsBasel from "../ExportLicense/DetailsBasel"
import ViewAttachments from "components/Application/ViewAttachments"
import RecallApplication from "components/Application/RecallApplication"

import DetailsDeliveryPartner from "pages/Application/DeliveryPartner/Details"
import DetailsAccreditation from "pages/Application/AccreditationRequest/Details"
import DetailsNoObjection from "pages/Application/NoObjectionRequest/Details"
import DetailsEnvironmentalAudit from "pages/Application/EnvironmentalAudit/Details"

const BaseApplicationView = props => {
  const [viewComponent, setviewComponent] = useState()

  useEffect(() => {
    // console.log(props.appDetails)
    if (
      props.appDetails.service_id === 4 ||
      props.appDetails.service_id === 3
    ) {
      if (props.appDetails.basel_convention) {
        setviewComponent(<DetailsBasel appDetails={props.appDetails} />)
      } else {
        setviewComponent(<DetailsRotterdam appDetails={props.appDetails} />)
      }
    } else if (props.appDetails.service_id === 2) {
      setviewComponent(<DisposalDetails appDetails={props.appDetails} />)
    } else if (props.appDetails.service_id === 1) {
      setviewComponent(<DetailsPlasticBags appDetails={props.appDetails} />)
    } else if (props.appDetails.delivery_partner_service_request) {
      setviewComponent(<DetailsDeliveryPartner appDetails={props.appDetails} />)
    } else if (props.appDetails.accreditation_request) {
      setviewComponent(<DetailsAccreditation appDetails={props.appDetails} />)
    } else if (props.appDetails.no_objection_letter_request) {
      setviewComponent(<DetailsNoObjection appDetails={props.appDetails} />)
    } else if (props.appDetails.environmental_audit_request) {
      setviewComponent(<DetailsEnvironmentalAudit appDetails={props.appDetails} />)
    }
  }, [])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>View Application | Staff</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={8}>
                <h6 className="page-title">{props.title}</h6>
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item active">View Application</li>
                </ol>
              </Col>
            </Row>
          </div>

          <Row>
            {props.recallApplication && props.recallApplication==true? <RecallApplication applicationId={props.appDetails.id} /> : null}
          </Row>

          <Row>
            <Col md={12}>
              <Decisions appDetails={props.appDetails} />
            </Col>
            {/* <Col md={4}>
              <History />
            </Col> */}
          </Row>
          <hr></hr>

          <Row>
            {/* Application Details View */}
            <Col md={12}>{viewComponent}</Col>
          </Row>

          <Row>
            <h4>Application Attachments</h4>
            <ViewAttachments
              attachments={props.appDetails.application_attachments}
            />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default BaseApplicationView
